import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Discount } from "@modules/discounts/types";
import { DiscountFormValues } from "@modules/discounts/validations";

import { editDiscountService } from "./service";
import { UseEditDiscountMutationOptions } from "./types";
import { listDiscountsQueryKey } from "../../queries/listDiscounts/query";
export function useEditDiscountMutation(
  id: string,
  options?: UseEditDiscountMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();
  const queryClient = useQueryClient();

  return useMutation<Discount, ApiError, Partial<DiscountFormValues>>({
    mutationFn: (data) => editDiscountService(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listDiscountsQueryKey(),
      });

      open?.({
        type: "success",
        message: translate("v1/discount_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
